<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import url('https://fonts.googleapis.com/css?family=Roboto');

body {
  font-family: 'Roboto', sans-serif;
  background: transparent;
}

.container {
  max-width: 980px;
  padding-left: 0;
  padding-right: 0;
}

.btn {
  border-radius: 0;
}

.btn-primary {
  background-color: #60ad0e;
  border-color: #60ad0e;
  &:hover,
  &:focus,
  &:active,
  &:hover:focus {
    background-color: #333!important;
    border-color: #333!important;
    outline: none!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue